export interface ISuppress {
    hardToMatch: boolean,
    voucher: boolean,
    pairedPatient: boolean
}